import UnitsList from './UnitsList.container';

export default UnitsList;
